/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class AudienceRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.replaceWith('apps.app.settings.ai-automation.audiences');
  }
}
